// 后台配置路由，暂时先手写
import disease from '@/views/questionBank/disease'
import subject from '@/views/questionBank/subject'
import questionDetails from '@/views/questionBank/questionDetails'
import questionResult from '@/views/questionBank/questionResult'
import questionIndex from '@/views/questionBank/questionIndex'
import errDisease from '@/views/questionBank/errDisease'
import errSubject from '@/views/questionBank/errSubject'
import colDisease from '@/views/questionBank/colDisease'
import colSubject from '@/views/questionBank/colSubject'

export const questionRouterMap = [
  {
    path: '/questionIndex',
    name: '心电图答题',
    meta: {
      moduleName: '每日一题'
    },
    component: questionIndex
  },
  {
    path: '/disease',
    name: '分类题库',
    meta: {
      moduleName: '每日一题'
    },
    component: disease
  },
  {
    path: '/subject',
    name: '分类题目',
    meta: {
      moduleName: '每日一题'
    },
    component: subject
  },
  {
    path: '/questionDetails',
    name: '题库详情',
    meta: {
      moduleName: '每日一题'
    },
    component: questionDetails
  },
  {
    path: '/questionResult',
    name: '查看结果',
    meta: {
      moduleName: '每日一题'
    },
    component: questionResult
  },
  {
    path: '/errDisease',
    name: '错题库',
    meta: {
      moduleName: '每日一题'
    },
    component: errDisease
  },
  {
    path: '/errSubject',
    name: '错题目',
    meta: {
      moduleName: '每日一题'
    },
    component: errSubject
  },
  {
    path: '/colDisease',
    name: '收藏题库',
    meta: {
      moduleName: '每日一题'
    },
    component: colDisease
  },
  {
    path: '/colSubject',
    name: '收藏题目',
    meta: {
      moduleName: '每日一题'
    },
    component: colSubject
  },
]



// WEBPACK FOOTER //
// ./src/router/question.js